if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyATC extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initializeIntersectionObserver();

        this.elements = {
          variantPicker: document.querySelector(`#ProductInfo-${this.dataset.sectionId} variant-radios`),
          stickyVariantPicker: this.querySelector('variant-radios'),
          variantPickerRadios: Array.from(
            document.querySelectorAll(`#ProductInfo-${this.dataset.sectionId} variant-radios input[type="radio"]`)
          ),
          stickyVariantPickerRadios: Array.from(this.querySelectorAll('variant-radios input[type="radio"]')),
          addToCartBtn: document.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`),
          addToCartBtnText: document.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}>span`),
          addToCartLabel: this.querySelector(`label[for="ProductSubmitButton-${this.dataset.sectionId}"]`),
          priceContainer: this.querySelector('.price'),
          price: this.querySelector('.price--regular'),
          compareAtPrice: this.querySelector('.price--compare'),
        };

        this.elements.variantPickerRadios.forEach((radio) => {
          radio.addEventListener('change', this.onVariantChange.bind(this, radio, false));
        });

        this.elements.stickyVariantPickerRadios.forEach((radio) => {
          radio.addEventListener('change', this.onVariantChange.bind(this, radio, true));
        });

        const radio = this.elements.stickyVariantPickerRadios.find((radio) => radio.checked);

        if (!radio.dataset.price) {
          this.updateOptions();
          this.updateMasterId();
        }

        this.renderProductPrice(radio.dataset.price, radio.dataset.compareAtPrice);
      }

      onVariantChange(radio, isSticky) {
        const target = isSticky ? this.elements.variantPickerRadios : this.elements.stickyVariantPickerRadios;
        const targetRadio = target.find((r) => r.value === radio.value);
        if (targetRadio && !targetRadio.checked) {
          targetRadio.checked = true;
          targetRadio.dispatchEvent(new Event('change'));

          if (!radio.dataset.price) {
            this.updateOptions();
            this.updateMasterId();
          }

          this.renderProductPrice(radio.dataset.price, radio.dataset.compareAtPrice);
        }
      }

      renderProductPrice(price, compareAtPrice) {
        if (price) {
          this.elements.price.textContent = price;
          this.elements.compareAtPrice.textContent = compareAtPrice ?? '';
        } else {
          const variantId = this.currentVariant.id;
          if (this.elements.addToCartLabel) this.elements.addToCartLabel.classList.add('disabled');

          fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.sectionId}`)
            .then((res) => res.text())
            .then((res) => {
              if (this.currentVariant.id !== variantId) return;

              const html = new DOMParser().parseFromString(res, 'text/html');
              const price = html.querySelector('sticky-atc .price');
              const label = html.querySelector('sticky-atc label.button');

              if (this.elements.priceContainer) this.elements.priceContainer.innerHTML = price.innerHTML;
              if (this.elements.addToCartLabel) {
                this.elements.addToCartLabel.innerHTML = label.innerHTML;
                this.elements.addToCartLabel.classList.remove('disabled');
              }
            });
        }
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio?.checked).value;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      initializeIntersectionObserver() {
        const parent = this;
        const header = document.querySelector('.header-wrapper');
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const shopifyChatElement = document.querySelector('#shopify-chat');
              const newsletterElement = document.querySelector('button .needsclick');
              const isHidden =
                (entry.isIntersecting && entry.boundingClientRect.top <= 100) || entry.boundingClientRect.top > 100;
              if (shopifyChatElement) {
                shopifyChatElement.style.display = isHidden ? 'block' : 'none';
              }
              if (newsletterElement) {
                newsletterElement.style.display = isHidden ? 'block' : 'none';
              }
              parent.classList.toggle('hidden', isHidden);
              header.classList.toggle('medium-hide', !isHidden);
              header.classList.toggle('large-up-hide', !isHidden);
            });
          },
          {
            root: null,
            rootMargin: '-100px',
            threshold: 0,
          }
        );

        document.querySelectorAll(this.dataset.target).forEach((el) => {
          observer.observe(el);
        });
      }
    }
  );
}
